import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const WarningBanner = () => {
  return (
    <Box background="tangerine200" borderRadius={{ all: 'abs008' }} padding="s16" gap="s4">
      <Box flexDirection="row" alignItems="center" gap="s4">
        <Icon.Medium icon="alert-sign" color="tangerine1000" />
        <Text.Normal weight="semibold" size="200">
          {i18n.t('finance.financial_workspace.settings.labor_cost.banner.title')}
        </Text.Normal>
      </Box>
      <Text.Normal size="200">
        {i18n.t('finance.financial_workspace.settings.labor_cost.banner.description')}
      </Text.Normal>
    </Box>
  )
}
